<ng-template #defaultText>
  <ng-container i18n="@@product-list.quantity_discount">
    Mengen&shy;rabatt
  </ng-container>
</ng-template>
<ng-container *ngIf="productData$ | async as product">
  <ng-container
    *ngIf="
      quantityDiscountHtmlByProductId$
        | async as quantityDiscountHtmlByProductId
    "
  >
    <div
      class="discount-container mt-2"
      *ngIf="
        product.quantity.has_discount &&
        quantityDiscountHtmlByProductId[product.product_id] as discountInfo
      "
      #overlayContainer
    >
      <a
        class="info-btn"
        [class.discount-active]="!!discountInfo.active"
        href="javascript:;"
        (mouseleave)="discountOverlay.hide()"
        (mouseenter)="discountOverlay.show($event, overlayContainer)"
        (blur)="discountOverlay.hide()"
        (focus)="discountOverlay.show($event)"
      >
        <ng-container *ngIf="discountInfo.label as text; else defaultText">
          <span [innerHTML]="text"></span>
        </ng-container>
      </a>
      <p-overlayPanel #discountOverlay>
        <ng-template pTemplate>
          <div [innerHTML]="discountInfo.table | sanitize : 'HTML'"></div>
        </ng-template>
      </p-overlayPanel>
    </div>
  </ng-container>
</ng-container>
